import { VersionManifest } from "./types/version.type";

/**
 * getVersionManifest function
 * Fetches the deployed version manifest, bypassing the HTTP cache so a freshly
 * published build is always detected even while a tab stays open. Uses a plain
 * fetch (not the axios client) as version.json is a static, unauthenticated
 * asset served from the SPA origin rather than the platform API.
 *
 * @returns A promise resolving to the deployed version manifest
 */
export const getVersionManifest = async (): Promise<VersionManifest> => {
  const response = await fetch("/version.json", { cache: "no-store" });

  if (!response.ok) {
    throw new Error(`Failed to fetch version manifest: ${response.status}`);
  }

  return response.json();
};
